/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var AcdAnchor = require("personalization-web-agent-views/AcdAnchor");
    var BaseModel = require("models/BaseModel");
    var AcdEditModel = require("personalization-web-agent-models/AcdEditModel");
    var SettingsCollection = require("collections/SettingsCollection");
    var Settings = require("codeTables/settings.json");
    var AcdController = {};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AcdController = BaseFeatureController.extend({
            initialize: function (options) {
                this.featureId = options.featureOptions.id;
                this.acdAnchorView = new AcdAnchor({
                    model: new BaseModel(),
                    isMessaging: this._isMessagingState(),
                    anchorSelector:options.featureOptions.anchorSelector,
                    featureId:this.featureId
                });
                this.listenTo(this.acdAnchorView, "acd:navigateToFeatureEdit", this._onNavigateToFeatureEdit, this);
            },
            getAnchorView: function (options) {
                 return this.acdAnchorView;
            },
            getAnchorModel: function () {
                return new (Backbone.Model.extend({}))();
            },

            _onNavigateToFeatureEdit: function () {
                LEPersonalization.loader.setLoader();
                this.settingsCollection = new SettingsCollection([], {contextType: Settings.CONTEXT_TYPE.ACCOUNT, contextCascading: true});
                this._getSettingsCollection();
            },
            _onFetchSuccess: function (model, response, options) {
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToFeatureEdit({
                    featureId: this.featureId,
                    controllerOptions:{
                        model:model,
                        isMessaging: this._isMessagingState(),
                        settingsCollection: this.settingsCollection
                    }
                });
            },
            _onFetchError: function (model, response, options) {
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                LEPersonalization.loader.closeLoader();
            },
            _isMessagingState: function() {
                return LE.sessionManager.hasAsyncMessagingFeature();
            },
            _getSettingsCollection: function() {
                var settingsOptions = {
                    groups: Settings.SETTING_GROUP.nvACDSettings,
                    success: _.bind(this._onSiteSettingsFetchSuccess, this),
                    error: _.bind(this._onFetchError, this)
                };
                this.settingsCollection.fetch(settingsOptions);
            },
            _onSiteSettingsFetchSuccess: function() {
                var model = new AcdEditModel();
                model.fetch({
                    success: _.bind(this._onFetchSuccess, this),
                    error: _.bind(this._onFetchError, this)
                });
            }
        });
    });
    return AcdController;

});
